<template>
  <router-view></router-view>
</template>
<style>
html,body,#app{
  height: 100%;
}

.app-container{
  padding:20px
}
</style>